import 'core-js/stable'
import { createBrowserHistory } from 'history'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { IntlProvider } from 'react-intl'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { ToastProvider } from 'react-toast-notifications'
import App from './App'
import './config/fontawesome'
import messages from './config/messages'
import { BankrollProvider } from './contexts'
import store from './store'
import './styles/index.scss'

const history = createBrowserHistory()
const queryClient = new QueryClient()

if (process.env.NODE_ENV === 'production') {
  // Initialize Google Analytics
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_TRACKING_ID)
  // Custom listener for Google Analytics pageviews
  history.listen(location =>
    ReactGA.pageview(location.pathname + location.search),
  )
  // Initial pageview
  ReactGA.pageview(window.location.pathname + window.location.search)
}

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale={navigator.language} messages={messages}>
      <Router history={history}>
        <ToastProvider>
          <QueryClientProvider client={queryClient}>
            <BankrollProvider>
              <App />
            </BankrollProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </ToastProvider>
      </Router>
    </IntlProvider>
  </Provider>,
  document.getElementById('root'),
)
